<script>
import ConsumerService from '../account-consumer.service'
import toasterService from '@/utils/toaster'
import messages from '../../../messages.js'
import { EventBus } from '@/event-bus'

const consumerService = new ConsumerService()
export default {
  name: 'ConsumerForgetPwd',

  data () {
    return {
      email: '',
      submitted: false,
      errorMessage: false
    }
  },

  methods: {

    /**
     * This method will call the forget Api
     */
    handleSubmit (e) {
      this.submitted = true
      this.$validator.validate().then(valid => {
        this.$store.commit('consumerEmailId', this.email)
        if (valid) {
          consumerService.forgetPwd({ 'email': this.email }).then(res => {
            if (this.email.includes('mailinator.com')) {
              this.$router.push('/reset/' + res.resetToken).catch(err => { console.error(err) })
            } else {
              EventBus.$emit('switchConsumerPage', 'consumerLogin')
              toasterService.onSuccess(messages['en-US'].label.emailTokenMsg)
            }
          }).catch(error => {
            this.errorMessage = error
          })
        }
      })
    }
  }
}
</script>

<template>
  <div
    id="consumer-forget-pwd"
    class="py-5"
  >
    <div
      v-if="errorMessage"
      class="alert alert-danger mx-auto col-sm-12 col-md-10"
      role="alert"
    >
      {{ errorMessage }}
    </div>
    <div>
      <h5 class="text-center pt-5">
        {{ $t ('label.resetPwd') }}
      </h5>
      <h6 class="text-center">
        {{ $t ('label.forgetPwdTxt') }}
      </h6>
      <div class="src-user-icon my-5">
        <i class="fa fa-user-circle-o text-primary fa-5x" />
      </div>
      <form @submit.prevent="handleSubmit">
        <div class="form-group mx-auto col-sm-12 col-md-8 py-5">
          <input
            v-validate="{ required: true, email: true }"
            id="consumerEmail"
            v-model="email"
            :class="{ 'is-invalid': submitted && errors.has('email') }"
            name="email"
            placeholder="Consumer user name"
            type="email"
            class="form-control"
          >
          <div
            v-if="submitted && errors.has('email')"
            class="invalid-feedback">{{ errors.first('email') }}</div>
        </div>
        <div class="mx-auto mt-4 col-sm-8 col-md-8">
          <button
            class="btn btn-primary btn-block"
          >
            {{ $t('label.submit') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>
